export const getUserNameInitials = (name: string) => {
    const initials = name.split(' ').map((word) => word[0]);
    return initials.join('').toUpperCase();
};
